//version 1.0.1

import { ENVIRONMENT } from "config/config";

export const allowedDomains = [
  "https://lesliesmilesolutions.ca", //for testing staging
  "https://janeclairdental.com", //Jane Clair Dental Clinic
  "https://markhamdentist.ca", //7 Days Dental
  "file://", //for localhost testing
];

export const clientsMasterList = [
  {
    name: "DF Clinic",
    id:
      ENVIRONMENT === "STAGING"
        ? "58ff6485421aa9383b00000a"
        : "5c588bdc56955a7b71462f1f",
    initials: "DF",
  },
  {
    name: "7 Days Dental",
    id:
      ENVIRONMENT === "STAGING"
        ? "64dca19f421aa92d859b297d"
        : "60035683421aa947a3e31010",
    initials: "7DD",
  },

  {
    name: "Jane Clair Dental",
    id:
      ENVIRONMENT === "STAGING"
        ? "4fc3afbeffdbff7755000938"
        : "4fc3afbeffdbff7755000938",
    initials: "JC",
  },
  {
    name: "Sheppard Centre Dental",
    id:
      ENVIRONMENT === "STAGING"
        ? "64dca314421aa92d859b29a0"
        : "4df7a16dfdde9cb79b000599",
    initials: "SC",
  },
  {
    name: "Oasispark Dental",
    id:
      ENVIRONMENT === "STAGING"
        ? "57d3f3d6421aa960230001db"
        : "57d3f3d6421aa960230001db",
    initials: "OD",
  },
  {
    name: "Aesthetic Implant Dentistry",
    id:
      ENVIRONMENT === "STAGING"
        ? "64dca4e7421aa92d859b29c"
        : "4df7a16dfdde9cb79b00030c",
    initials: "AID",
  },

  {
    name: "Luna Dentistry Midtown Toronto",
    id:
      ENVIRONMENT === "STAGING"
        ? "5bebb01b56955a1cd0013b0b"
        : "5bebb01b56955a1cd0013b0b",
    initials: "LD",
  },

  {
    name: "Luna Dentistry Richmond Hill",
    id:
      ENVIRONMENT === "STAGING"
        ? "65773aea421aa906fb459f8a"
        : "65773aea421aa906fb459f8a",
    initials: "LD",
  },
];

export const initialClinicDetails = {
  name: "DF Clinic",
  id: "58ff6485421aa9383b00000a",
  initials: "DF",
};

export const sampleWidgetUser = {
  email: "sample_email12f13fdgdf@gmail.com",
  full_name: "Michael Hinacay Test 1",
  message: "",
  token:
    "eyJhbGciOiJIUzI1NiJ9.eyJwYXRpZW50X2lkIjoiNjM1MjgzNzU0MjFhYTkzNWFlZTZlN2I4IiwiaWF0IjoxNjY2MzUxOTkwLCJleHAiOjE3Mjk1MTAzOTB9.iaiQfWG2o4sNMXZ7BaFAQN1Lc6nnSonqAErNxFYJlps",
  lead_id: "63528375421aa935aee6e7b8",
  mobile: "09489059958",
  first_message: "This is a first message",
};

export const sampleWidgetUser_1 = {
  email: "hinacay.johnmic3343hael@gmail.com",
  full_name: "Chat Widget Tester 3",
  message: "",
  mobile: "09489059958",
  first_message: "This is a first message",
  token:
    "eyJhbGciOiJIUzI1NiJ9.eyJwYXRpZW50X2lkIjoiNjM1MTQ1ZmQ0MjFhYTkxYzViMjgyMTE3IiwiaWF0IjoxNjY2MjcwNzE3LCJleHAiOjE3Mjk0MjkxMTd9.32wCLB-2G-vtwRMqH3LjmwBqCPETVhNewA8XVAhifl8",
  lead_id: "635145fd421aa91c5b282117",
  timeStamp: 1666856952891,
};

export const sampleWidgetUser_3 = {
  email: "newemail3@gmail.com",
  full_name: "asd",
  message: "",
  token: "",
  lead_id: "",
  first_message: "asd",
};

//Clinic IDS
// 7 Days Dental - 60035683421aa947a3e31010
// Downtown Dentistry - 555222d3421aa913f601aa5a
// Forestbrook Dental - 5564bc2f421aa930d4001d87
// My City Dental - 5e9e13d156955a0a43f4636c
// Oasispark Dental - 57d3f3d6421aa960230001db
// Woo Dental - 60c3876a421aa97ec6adb59a
// World Dental - 526d1dee01591101c2000308
// Wortley Road Dental - 5ca6749756955a6e0842adfd
// Jane Clair Dental - 4fc3afbeffdbff7755000938
